export default __webpack_public_path__ + "grid-4-active-qSL.png";